<template>
    <iframe :src="iframeSrc" id="mobsf" width="100%" height="100%" scrolling="no" frameborder="0"></iframe>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            dept: state => state.user.dept
        }),
        iframeSrc() {
          console.log(this.dept)
            if (!this.dept || this.dept === '-') {
                return 'https://zgkd.zzrcfzjt.com/webroot/decision/view/duchamp?viewlet=枣工快递main.fvs&page_number=1'
            } else {
                return `https://zgkd.zzrcfzjt.com/webroot/decision/view/duchamp?viewlet=枣工快递area.fvs&page_number=1&area=${this.dept}`
            }
        }
    }
}
</script>
